<template>
    <div class="lite_popup add_drive" v-show="auth.show && !hidePopup">
        <div class="lite_popup_box lite_add_drive_box">
            <div class="lite_popup_title">
                <span v-if="auth.type == 'Website'">{{ $t('language.common.addWebsite') }}</span>
                <span v-else>{{ auth.did ? $t('language.leftBanner.edit') : $t('language.common.addCloud') }}</span>
                <div class="icon white-close dialog-close" @click="close"></div>
            </div>
            <div class="lite_popup_content">
                <div class="add_drive_type">
                    <div class="add_drive_icon" :class="'drive-icon-' + auth.type"></div>
                    <span>{{ cloudTypeToName(auth.type) }}</span>
                    <!-- iCloudPhotos 提示信息 -->
                    <div v-if="auth.type == 'ICloudPhotos'" class="add_drive_tip_icloudphotos">
                      <div>{{ $t('language.popup.addCloudPopup.iCloudPhotosTip') }}</div>
                      <div>
                        <span>{{ $t('language.popup.addCloudPopup.iCloudPhotosTip1') }}</span>
                        <el-tooltip placement="top" effect="light">
                          <div slot="content">
                            <font v-html="$t('language.popup.addCloudPopup.iCloudPhotosTip1Q')"></font>
                          </div>
                          <div class="icon-util question-mark plus_icloudphotos_tips_icon"></div>
                        </el-tooltip>
                      </div>
                      <div>{{ $t('language.popup.addCloudPopup.iCloudPhotosTip2') }}</div>
                      <div>3. {{ $t('language.popup.addCloudPopup.iCloudDomainTip') }}</div>
                    </div>
                    <!-- GooglePhotos 提示信息 -->
                    <div v-if="auth.type == 'GooglePhotos'" class="add_drive_tip_googlephotos">
                      <div>{{ $t('language.popup.tips') }}</div>
                      <div>{{ $t('language.popup.cloudExploerPopup.googlePhotosV2TipsDesc') }}</div>
                      <ol>
                        <li>{{ $t('language.popup.cloudExploerPopup.googlePhotosV2Tips1') }}</li>
                        <li>{{ $t('language.popup.cloudExploerPopup.googlePhotosV2Tips2') }}</li>
                        <li>{{ $t('language.popup.cloudExploerPopup.googlePhotosV2Tips3') }}</li>
                        <li>{{ $t('language.popup.cloudExploerPopup.googlePhotosV2Tips4') }}</li>
                      </ol>
                    </div>
                    <!-- GoogleDrive 提示信息 -->
                    <div v-if="auth.type == 'GoogleDrive'" class="add_drive_tip_googledrive">
                      <div>{{ $t('language.popup.addCloudPopup.googleDrive2FATip') }}</div>
                      <div>{{ $t('language.popup.addCloudPopup.googleDrive2FATip1') }}</div>
                    </div>
                    <!-- Egnyte 提示信息 -->
                    <div v-if="auth.type == 'Egnyte'" class="add_drive_tip_egnyte">
                        <div class="egnyte_tip_title">Create an Egnyte App before connecting:</div>
                        <ol>
                            <li>
                                Open
                                <a href="https://developers.egnyte.com/my-apps" target="_blank" rel="noopener noreferrer">Egnyte My Apps</a>
                                with an Egnyte domain administrator account, then create a new app.
                            </li>
                            <li>
                                Enter the App Name, Description and Egnyte Domain. For example, enter
                                <b>acme</b> if the domain URL is <b>https://acme.egnyte.com</b>.
                            </li>
                            <li>
                                Select <b>Internal Application (own company use only)</b>, <b>New App</b> and
                                <b>Web App</b>, then request the <b>Prod Collaborate</b> API. After approval,
                                enter the domain, API key and secret below.
                            </li>
                        </ol>
                    </div>
                </div>
                <el-form :model="auth" label-width="110px">
                    <!-- 一般云盘 -->
                    <el-form-item :label="$t('language.common.type')" style="display:none;">
                        <el-input v-model="auth.type" disabled></el-input>
                    </el-form-item>
                    <!-- 用户为该云盘类型配置过自己的 OAuth App 时，新增云盘必须明确选择。 -->
                    <el-form-item v-if="showAppSelection" :label="$t('language.liteApp.selectApp')">
                        <el-select v-model="auth.aid" class="lite_add_drive_select">
                            <el-option v-if="auth.systemAppAvailable" :label="$t('language.liteApp.defaultApp')" value=""></el-option>
                            <el-option v-for="app in auth.customApps" :key="app.id" :label="app.name" :value="app.id"></el-option>
                        </el-select>
                        <div class="lite_add_drive_app_tip">{{ $t('language.liteApp.selectAppTip') }}</div>
                    </el-form-item>
                    <el-form-item :label-width="/AmazonS3|Wasabi|Egnyte/.test(auth.type) ? '160px' : '110px'" :label="auth.type == 'Website' ? $t('language.common.websiteName') : $t('language.popup.addCloudPopup.displayName')">
                        <el-input v-model="auth.name"></el-input>
                    </el-form-item>
                    <!-- AmazonS3 -->
                    <div v-if="auth.type == 'AmazonS3'">
                        <el-form-item label-width="160px" :label="$t('language.popup.addCloudPopup.accessKeyId')">
                            <el-input v-model="auth.amazons3.accessKeyId" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item label-width="160px" :label="$t('language.popup.addCloudPopup.secretAccessKey')">
                            <el-input v-model="auth.amazons3.secretAccessKey" :disabled="auth.did!=null" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label-width="160px" :label="$t('language.popup.addCloudPopup.bucketOptional')">
                            <el-input v-model="auth.amazons3.bucket" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item label-width="160px" :label="$t('language.popup.addCloudPopup.regionOptional')">
                            <el-input v-model="auth.amazons3.region"></el-input>
                        </el-form-item>
                        <el-form-item label-width="160px" :label="$t('language.popup.addCloudPopup.endpointOptional')">
                            <el-input v-model="auth.amazons3.endpoint"></el-input>
                        </el-form-item>
                    </div>
                    <!-- Egnyte -->
                    <div v-if="auth.type == 'Egnyte'" class="egnyte_form">
                        <el-form-item label-width="160px" :label="$t('language.popup.domain')">
                            <span class="egnyte_prefix">https://</span>
                            <el-input class="egnyte_domain" v-model="auth.egnyte.domain" :disabled="auth.did!=null"></el-input>
                            <span class="egnyte_suffix">.egnyte.com</span>
                        </el-form-item>
                        <el-form-item label-width="160px" :label="$t('language.popup.addCloudPopup.accessKeyId')">
                            <el-input v-model="auth.egnyte.accessKeyId" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item label-width="160px" :label="$t('language.popup.addCloudPopup.secretAccessKey')">
                            <el-input v-model="auth.egnyte.secretAccessKey" :disabled="auth.did!=null" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label-width="160px" :label="$t('language.popup.email')">
                            <el-input v-model="auth.egnyte.email" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item label-width="160px" :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.egnyte.password" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <!-- Wasabi -->
                    <div v-if="auth.type == 'Wasabi'">
                        <el-form-item label-width="160px" :label="$t('language.popup.addCloudPopup.accessKeyId')">
                            <el-input v-model="auth.wasabi.accessKeyId" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item label-width="160px" :label="$t('language.popup.addCloudPopup.secretAccessKey')">
                            <el-input v-model="auth.wasabi.secretAccessKey" :disabled="auth.did!=null" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <!-- ICloudPhotos 和 ICloudDrive -->
                    <div v-if="auth.type == 'ICloudPhotos' || auth.type == 'ICloudDrive'">
                        <el-form-item :label="$t('language.popup.domain')">
                            <el-select v-model="auth.icloud.domain" :disabled="auth.did!=null || auth.icloud.sessionId!=''" class="lite_add_drive_select">
                                <el-option label="www.icloud.com" value="com"></el-option>
                                <el-option label="www.icloud.com.cn" value="cn"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.appleId')">
                            <el-input v-model="auth.icloud.appleId" :disabled="auth.did!=null || auth.icloud.sessionId!=''"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.icloud.password" :type="showPassword ? 'text' : 'password'" :disabled="auth.icloud.sessionId!=''">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                        <div  class="icloud_code_div" v-if="auth.icloud.sessionId!=''">
                            <el-form-item :label="$t('language.popup.code')">
                                <el-input class="code_input" v-model="auth.icloud.code" maxlength="6"></el-input>
                                <el-button class="send_code_btn" :disabled="auth.icloud.secs > 0" @click="icloudSendCode">{{ $t('language.popup.resendCode') + (auth.icloud.secs > 0 ? "(" + auth.icloud.secs + "s)" : "") }}</el-button>
                            </el-form-item>
                        </div>
                    </div>
                    <!-- FTP -->
                    <div v-if="auth.type == 'FTP'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.protocol')">
                            <el-select v-model="auth.ftp.protocol" class="lite_add_drive_select">
                                <el-option label="ftp-plain" value="ftp-plain"></el-option>
                                <el-option label="ftps-explicit" value="ftps-explicit"></el-option>
                                <el-option label="ftps-implicit" value="ftps-implicit"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.ftp.host" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                            <el-input v-model="auth.ftp.port" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.ftp.username" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.ftp.password" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passive')">
                            <div class="switch-box">
                                <el-switch v-model="auth.ftp.passive" active-color="#5166BD"></el-switch>
                            </div>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.encoding')">
                            <el-select v-model="auth.ftp.encoding" class="lite_add_drive_select">
                                <el-option label="ISO-8859-1" value="ISO-8859-1"></el-option>
                                <el-option label="UTF-8" value="UTF-8"></el-option>
                                <el-option label="GBK" value="GBK"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                            <el-input v-model="auth.ftp.path"></el-input>
                        </el-form-item>
                    </div>
                    <!-- SFTP -->
                    <div v-if="auth.type == 'SFTP'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.sftp.host" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                            <el-input v-model="auth.sftp.port" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.sftp.username" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.sftp.password" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.privateKey')">
                            <el-input v-model="auth.sftp.privateKey" type="textarea"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passphrase')">
                            <el-input v-model="auth.sftp.passphrase" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                            <el-input v-model="auth.sftp.path"></el-input>
                        </el-form-item>
                    </div>
                    <!-- WebDAV -->
                    <div v-if="auth.type == 'WebDAV'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.webdav.url" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.webdav.username" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.webdav.password" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <!-- MySQL -->
                    <div v-if="auth.type == 'MySQL'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.mysql.host" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                            <el-input v-model="auth.mysql.port" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.mysql.username" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.mysql.password" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <!-- Backblaze -->
                    <div v-if="auth.type == 'Backblaze'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.keyID')">
                            <el-input v-model="auth.backblaze.applicationKeyId" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.applicationKey')">
                            <el-input v-model="auth.backblaze.applicationKey" :disabled="auth.did!=null" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <!-- MediaFire -->
                    <div v-if="auth.type == 'MediaFire'">
                        <el-form-item :label="$t('language.popup.email')">
                            <el-input v-model="auth.mediafire.email"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.mediafire.password" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <!-- SugarSync -->
                    <div v-if="auth.type == 'SugarSync'">
                        <el-form-item :label="$t('language.popup.email')">
                            <el-input v-model="auth.sugarsync.email"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.sugarsync.password" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <!-- MEGA -->
                    <div v-if="auth.type == 'MEGA'">
                        <el-form-item :label="$t('language.popup.email')">
                            <el-input v-model="auth.mega.email"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.mega.password" :type="showPassword ? 'text' : 'password'">
                                <template #suffix>
                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <!-- Website -->
                     <div v-if="auth.type == 'Website'">
                        <!-- 站点 -->
                        <div class="website_box">
                            <!-- 标题 -->
                            <div class="website_box_title">
                                <div class="website_box_title_text">{{ $t('language.website.addSite') }}</div>
                                <div class="website_box_title_add" @click="addSite()">{{ $t('language.website.addSiteMore') }}</div>
                            </div>
                            <!-- 子集合 -->
                            <div class="website_items myscroll">
                                <div class="website_item2 website_item_site" v-for="(site, index) in auth.website.sites" :key="index">
                                    <!-- 基本参数 -->
                                    <el-form-item :label="$t('language.popup.addCloudPopup.server') + ' ' + (index + 1)">
                                        <span class="website_host_prefix">sftp://</span>
                                        <el-input class="website_host" v-model="site.host"></el-input>
                                        <el-input class="website_port" v-model="site.port"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                        <el-input v-model="site.username"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                                        <el-input v-model="site.password" :type="showPassword ? 'text' : 'password'">
                                            <template #suffix>
                                                <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                    <!-- 更多 -->
                                    <div class="website_more">
                                        <div class="website_more_btn"  :class="site.show?'open':'close'" @click="site.show=!site.show">
                                            <span>{{ $t('language.popup.addCloudPopup.advanced') }}</span>
                                            <div></div>
                                        </div>
                                        <div class="website_more_remove" @click="delSite(index)">{{ $t('language.website.removeSite') }}</div>
                                    </div>
                                    <!-- 高级参数 -->
                                    <div class="website_more_content" v-show="site.show">
                                        <el-form-item :label="$t('language.popup.addCloudPopup.privateKey2')">
                                            <el-input v-model="site.privateKey" type="textarea"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('language.popup.addCloudPopup.passphrase')">
                                            <el-input v-model="site.passphrase" :type="showPassword ? 'text' : 'password'">
                                                <template #suffix>
                                                    <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                                </template>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                                            <el-input v-model="site.path"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 数据库 -->
                         <div class="website_box">
                            <!-- 标题 -->
                            <div class="website_box_title">
                                <div class="website_box_title_text">{{ $t('language.website.addDb') }}</div>
                                <div class="website_box_title_add" @click="addDB()">{{ $t('language.website.addDbMore') }}</div>
                            </div>
                            <!-- 子集合 -->
                             <div class="website_items myscroll">
                                <div class="website_item2 website_item_db" v-for="(db, index) in auth.website.dbs" :key="index">
                                    <!-- 基本参数 -->
                                    <el-form-item :label="$t('language.popup.addCloudPopup.server') + ' ' + (index + 1)">
                                        <el-input class="website_host" v-model="db.host"></el-input>
                                        <el-input class="website_port" v-model="db.port"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                        <el-input v-model="db.username"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                                        <el-input v-model="db.password" :type="showPassword ? 'text' : 'password'">
                                            <template #suffix>
                                                <div :class="showPassword ? 'open_eye' : 'close_eye'" @click="showPassword = !showPassword"></div>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                    <!-- 更多 -->
                                    <div class="website_more">
                                        <div class="website_more_btn" :class="db.show?'open':'close'" @click="db.show=!db.show">
                                            <span>{{ $t('language.popup.tips') }}</span>
                                            <div></div>
                                        </div>
                                        <div class="website_more_remove" @click="delDB(index)">{{ $t('language.website.removeDb') }}</div>
                                    </div>
                                    <!-- 提示信息 -->
                                    <div class="website_more_content" v-show="db.show" v-html="$t('language.popup.addCloudPopup.mySQLTips')"></div>
                                </div>
                            </div>
                         </div>
                     </div>
                </el-form>
            </div>
            <div class="lite_popup_footer">
                <button @click="submit()">
                    <i v-if="auth.loading" class="el-icon-loading" style="color:#fff;"></i>
                    <span v-if="auth.type == 'Website'">{{ $t('language.common.addWebsite') }}</span>
                    <span v-else>{{ auth.did ? $t('language.leftBanner.edit') : $t('language.common.addCloud') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>


<script>
import commonUtils from "@/js/workspace/common_util.js";
import { Message } from "element-ui";

export default {
    props: {
        auth: Object,
    },
    data() {
        return {
            showPassword: false,
        }
    },
    methods: {
      // 云盘类型转云盘默认名称
      cloudTypeToName(cloud) {
        let name = cloud;
        if (cloud == 'GoogleWorkspace') {
          name = 'Google Workspace';
        } else if (cloud == 'GoogleDrive') {
          name = 'Google Drive';
        } else if (cloud == 'OneDrive') {
          name = 'OneDrive';
        } else if (cloud == 'Dropbox') {
          name = 'Dropbox';
        } else if (cloud == 'FTP') {
          name = 'FTP';
        } else if (cloud == 'SFTP') {
          name = 'SFTP';
        } else if (cloud == 'Box') {
          name = 'Box';
        } else if (cloud == 'PCloud') {
          name = 'pCloud';
        } else if (cloud == 'MediaFire') {
          name = 'MediaFire';
        } else if (cloud == 'MySQL') {
          name = 'MySQL';
        } else if (cloud == 'Backblaze') {
          name = 'Backblaze';
        } else if (cloud == 'Website') {
          name = 'Website';
        } else if (cloud == 'GooglePhotos') {
          name = 'Google Photos';
        } else if (cloud == 'ICloudPhotos') {
          name = 'iCloud Photos';
        } else if (cloud == 'ICloudDrive') {
          name = 'iCloud Drive';
        } else if (cloud == 'AmazonS3') {
          name = 'Amazon S3';
        } else if (cloud == 'MEGA') {
          name = 'MEGA';
        } else if (cloud == 'Wasabi') {
          name = 'Wasabi';
        } else if (cloud == 'DropboxBusiness') {
          name = 'Dropbox Business';
        }
        return name;
      },
      close() {
        this.auth.show = false;
        this.auth.icloud.sessionId = "";
        this.auth.icloud.code = "";
      },
      icloudSendCode() {
        if (this.auth.icloud.secs > 0) {
          return;
        } else {
          this.auth.icloud.code = "";
          this.submit();
        }
      },
        submit() {
            if (this.auth.type == 'Website' && this.auth.website.dbs.length==0 && this.auth.website.sites.length==0) {
                Message.warning("You should add Website Files or a Database Server.");
            } else {
                if (!this.auth.loading) {
                    this.$emit('submit');
                }
            }
        },
        addSite() {
            let sftp = {
                host: '',
                port: '22',
                username: '',
                password: '',
                privateKey: '',
                passphrase: '',
                path: '',
                show: false,
            };
            this.auth.website.sites.push(sftp);
        },
        delSite(index) {
            this.auth.website.sites.splice(index, 1);
        },
        addDB() {
            let db = {
                host: '',
                port: '3306',
                username: '',
                password: '',
                show: false,
            };
            this.auth.website.dbs.push(db);
        },
        delDB(index) {
            this.auth.website.dbs.splice(index, 1);
        },
        isDemoUser() {
            return commonUtils.isDemoUser();
        },
    },
    computed: {
        showAppSelection() {
            return !this.auth.did && this.auth.customApps && this.auth.customApps.length > 0;
        },
        hidePopup() {
            return !this.showAppSelection && ['OneDrive','Dropbox','Box','PCloud','GoogleWorkspace','OneDriveBusiness','DropboxBusiness','BoxBusiness','SharePoint','PutIO','FourShared','BaiDu','Flickr','Evernote','Gmail','Outlook'].includes(this.auth.type)
        },
    },
    watch: {
        'auth.show'(val) {
            if (val && this.isDemoUser()) {
                commonUtils.logoutAndJumpToSign();
            } else if (val && this.hidePopup) {
                this.$nextTick(() => {
                    this.$emit('submit');
                });
            } else if (val && this.auth.type=='Website') {
                if (this.auth.website.sites.length == 0) {
                    if (this.auth.website.dbs.length == 0) {
                        this.addSite();
                        this.addDB();
                    }
                }
            }
        }
    },
};
</script>

<style>
.lite_popup_box.lite_add_drive_box {
  width: 680px;
}

.add_drive .el-form-item__label {
  position: relative;
  top: 10px;
}

.switch-box {
  padding-top: 10px;
}
/* 密码眼睛位置调整 */
.lite_popup.add_drive .el-icon-view::before {
    position: relative;
    top: 7px;
}
.el-input__inner[type=password] {
    height: 40px;
}
.el-input__inner:focus {
  border-color: #5166BD;
}
.el-textarea__inner:focus {
  border-color: #5166BD;
}
/* 站点 */
.website_box {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;
}
/* 标题栏 */
.website_box_title {
    margin-top: 30px;
}
/* 标题栏文字 */
.website_box_title_text {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    height: 20px;
    line-height: 20px;
    display: inline-block;
}
/* 标题栏添加文字 */
.website_box_title_add {
    font-size: 14px;
    font-weight: normal;
    color: #5562B4;
    float: right;
    height: 20px;
    line-height: 20px;
    padding-left: 26px;
    background-image: url("../../assets/images/lite/icon/add.svg");
    background-position: left center;
    background-repeat: no-repeat;
    background-size: 16px;
    cursor: pointer;
    user-select: none;
}
.website_box_title_add:hover {
    text-decoration: underline;
}
/* 子集合 */
.website_items {
    max-height: 245px;
    overflow: auto;
}
/* 子节点 */
.website_item2 {
    padding: 10px;
    padding-left: 0px;
    border: 1px solid #5166BD;
    border-radius: 6px;
    margin-top: 20px;
    margin-right: 10px;
}
/* 输入框间距 */
.website_item2 .el-form-item {
    margin-bottom: 0px;
}
/* Label 左对齐 */
.website_item2 .el-form-item__label {
    text-align: left;
    padding-left: 10px;
    padding-right: 0px;
}
/* Host 前缀 */
.egnyte_prefix,
.egnyte_suffix,
.website_host_prefix {
    display: inline-block;
    width: 35px;
    height: 40px;
    line-height: 40px;
    background-color: #e6e7eb;
    padding: 0 10px;
    vertical-align: middle;
    border-radius: 4px;
    color: #606266;
    position: relative;
    top: -1px;
}
.egnyte_prefix {
    width: 45px;
}
.egnyte_suffix {
    width: 75px;
}
.egnyte_form .egnyte_domain {
    width: 310px;
}
/* Host 宽度 */
.website_item_site .website_host {
    width: 330px;
}
/* 数据库 Host 宽度 */
.website_item_db .website_host {
    width: 389px;
}
/* Port 宽度 */
.website_item_db .website_port,
.website_item_site .website_port {
    width: 103px;
    margin-left: 5px;
}
/* 更多 */
.website_more {
    padding-top: 20px;
    padding-bottom: 10px;
    user-select: none;
}
/* 更多-按钮 */
.website_more_btn {
    font-size: 14px;
    font-weight: normal;
    color: #5562B4;
    display: inline-block;
    cursor: pointer;
    margin-left: 10px;
}
.website_more_btn>span {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
}
.website_more_btn>div {
    width: 16px;
    height: 16px;
    background-image: url("../../assets/images/lite/icon/more.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 16px;
    display: inline-block;
    vertical-align: middle;
}
.website_more_btn.open>div {
    transform: rotate(-180deg);
}
/* 更多-删除 */
.website_more_remove {
    font-size: 14px;
    font-weight: normal;
    color: #F56C6C;
    float: right;
    height: 20px;
    line-height: 20px;
    padding-left: 26px;
    background-image: url("../../assets/images/lite/icon/remove.svg");
    background-position: left center;
    background-repeat: no-repeat;
    background-size: 16px;
    cursor: pointer;
}
.website_more_remove:hover {
    text-decoration: underline;
}
/* 提示文字 */
.website_more_content {
    color: #606266;
    padding: 10px;
    font-size: 13px;
    line-height: 20px;
}
.website_more_content>.add-mysql-link {
    display: block;
    line-height: 18px;
    margin: 5px 0px;
}

.lite_add_drive_select {
    width: 100%;
}

.lite_add_drive_select .el-input__suffix {
    height: 36px;
    top: 8px;
}
.lite_add_drive_app_tip {
  line-height: 18px;
  margin-top: 5px;
  color: #9aa3b4;
  font-size: 12px;
}

.icloud_code_div .code_input {
    width: 260px;
}

.icloud_code_div .send_code_btn {
    width: 250px;
    margin-top: 10px;
}

.send_code_btn {
    height: 40px;
    float: right;
}
.send_code_btn:hover {
  background: #5167bd2e;
  border-color: #5166BD;
  color: #606266;
}
.send_code_btn:focus {
  background: transparent;
  border-color: #DCDFE6;
  color: #606266;
}
.send_code_btn:active {
  background: #5167bd41;
  border-color: #5166BD;
  color: #606266;
}
.add_drive_type {
  border-bottom: 1px solid #DCDFE6;
  padding-bottom: 10px;
  margin-bottom: 20px;
}
.add_drive_type>.add_drive_icon {
  width: 60px;
  height: 60px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}
/* iCloud Photos 提示文字 */
.add_drive_tip_icloudphotos {
  background-color: #F0F8FF;
  border-radius: 10px;
  margin-top: 10px;
  padding: 20px;
  padding-bottom: 10px;
}
.add_drive_tip_icloudphotos>div {
  margin-bottom: 10px;
}
.plus_icloudphotos_tips_icon {
  position: relative;
  top: 5px;
}
/* GoogleDrive 提示文字 */
/* Google Photos 提示文字 */
.add_drive_tip_googledrive,
.add_drive_tip_googlephotos {
  background-color: #F0F8FF;
  border-radius: 10px;
  margin-top: 10px;
  padding: 20px;
  padding-bottom: 10px;
}
.add_drive_tip_googledrive>*,
.add_drive_tip_googlephotos>* {
  margin-bottom: 10px;
  line-height: 25px;
}
/* Egnyte 提示文字 */
.add_drive_tip_egnyte {
    background-color: #F0F8FF;
    border-radius: 10px;
    margin-top: 10px;
    padding: 20px;
    padding-bottom: 10px;
    color: #606266;
}
.add_drive_tip_egnyte .egnyte_tip_title {
    font-weight: bold;
    margin-bottom: 8px;
}
.add_drive_tip_egnyte ol {
    margin: 0;
    padding-left: 22px;
}
.add_drive_tip_egnyte li {
    line-height: 20px;
    margin-bottom: 8px;
}
.add_drive_tip_egnyte a {
    color: #5562B4;
    text-decoration: underline;
}
.open_eye,
.close_eye {
    cursor: pointer;
    margin-top: 14px;
    width: 30px;
    height: 30px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 20px;
    display: inline-block;
    vertical-align: middle;
}
.open_eye {
    background-image: url("../../assets/images/lite/icon/open_eye.svg");
}
.close_eye {
    background-image: url("../../assets/images/lite/icon/close_eye.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/lite_add_drive.vue